import "leaflet-image-transform/dist/L.ImageOverlay.Transform.min.js";
import { useEffect, useRef } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';

const S11405141 = ({ setLoading }) => {
  const map = useMap();
  const transformedImagesRef = useRef([]);
  const popupRef = useRef(null);
  
  
    
  useEffect(() => {
    const opacity = parseFloat(localStorage.getItem('opacity'))
    const imageUrls = [
      '/storage/flipped_vertical.png',
      '/storage/flipped_vertical.png'
    ];

    const coordinates4326 = [[
      [164.92452113533597, -1.2777790971040832],
      [-104.88968468212113, -1.3129551308424472],
      [-14.924810844950915, -1.4995386300325666],
      [74.88997439059544, -1.4645924336149816],
      [164.92452113533597, -1.2777790971040832]
    ]];

    const coordinates = coordinates4326[0].map(([lon, lat]) => [lat, lon]);
    const imageCorners = [
      coordinates[3],
      coordinates[0],
      coordinates[1],
      coordinates[2],
    ];

    const transformedImages = [];

    imageUrls.forEach((url) => {
      if (url && imageCorners.length === 4) {
        const transformedImage = L.imageOverlay.transform(url, imageCorners, {
          editable: false,
          interactive: false,
          scalable: false,
          draggable: false,
          rotatable: false,
          fit: true,
            opacity: opacity
        });

        
          transformedImage.addTo(map);
          transformedImages.push(transformedImage);

          const element = transformedImage.getElement();
          if (element) {
            element.style.border = 'none';
            element.style.outline = 'none';
            element.style.boxShadow = 'none';
          }
      
      }
    });

    transformedImagesRef.current = transformedImages;

    return () => {
      transformedImages.forEach(image => {
        if (map.hasLayer(image)) {
          map.removeLayer(image);
        }
      });
    };
  }, [map, localStorage.getItem('opacity')]);

  useEffect(() => {
    const imgLayer = transformedImagesRef.current[1];
    if (imgLayer) {
      const img = imgLayer._rawImage;

      if (img) {
        if (img.complete) {
          console.log('✅ Image already loaded (cached).');
          setLoading(false);
        } else {
          setLoading(true);
          img.onload = () => {
            console.log('✅ Image finished loading.');
            setLoading(false);
          };
        }
      }
    }
  }, [setLoading]);

  return null;
};

export default S11405141;
